import { useTranslation } from 'react-i18next';
import { ProductForm } from '@features/product-form';

export function ProductNewPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('products.newTitle')}</h1>
        <p className="text-sm opacity-70">{t('products.newSubtitle')}</p>
      </header>
      <ProductForm />
    </div>
  );
}
